import React from 'react';
import { FileText, Zap, Book, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="min-h-[100svh] flex flex-col justify-center pt-4 pb-6 md:pt-12 md:pb-16 px-4 bg-gradient-to-b from-blue-50 to-white" data-id="element-103">
      <div className="max-w-5xl mx-auto text-center w-full" data-id="element-104">
        {/* Badge */}
        <div className="inline-block bg-blue-100 text-blue-800 font-semibold px-3 py-1 rounded-full text-[11px] md:text-sm mb-2 md:mb-6 uppercase tracking-wide" data-id="element-105">
          Todo tu año de Lengua resuelto.
        </div>

        {/* Headline */}
        <h1 className="text-2xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight mb-3 md:mb-6 leading-tight" data-id="element-106">
          MegaPack Lengua 360 — 12 tomos completos{' '}
          <br className="hidden md:block" data-id="element-107" />
          <span className="text-blue-600" data-id="element-108">
            para docentes de primaria y secundaria
          </span>
        </h1>

        {/* Image */}
        <div className="flex justify-center mb-3 md:mb-6" data-id="element-109">
          <a href="#comprar" className="block cursor-pointer transform transition hover:scale-105" data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/2o1hejRV4784SVuexEKae2/48.png" alt="Lengua Pack - Megapack Lengua 360 Primaria y Secundaria" loading="eager" fetchPriority="high" decoding="async" className="max-h-[35svh] md:max-h-none md:w-full md:max-w-md w-auto rounded-2xl drop-shadow-2xl" data-id="element-111" />
          </a>
        </div>

        {/* Subheadline - hide on small mobile to save vertical space */}
        <p className="hidden sm:block text-base md:text-2xl text-gray-600 font-medium mb-4 md:mb-8 max-w-3xl mx-auto italic" data-id="element-112">
          +180 recursos de Lengua creados para docentes que están hartos de
          improvisar. Actividades, comprensión lectora y gramática listos para
          el aula, alineados al currículo argentino 2026.
        </p>

        {/* Benefits inline row */}
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mb-3 md:mb-6 text-xs md:text-base font-medium text-gray-700" data-id="element-113">
          <div className="flex items-center gap-1.5" data-id="element-114">
            <FileText className="w-4 h-4 text-blue-600" data-id="element-115" />
            100% PDF
          </div>
          <div className="flex items-center gap-1.5" data-id="element-116">
            <Zap className="w-4 h-4 text-yellow-600" data-id="element-117" />
            Acceso inmediato
          </div>
          <div className="flex items-center gap-1.5" data-id="element-118">
            <Book className="w-4 h-4 text-sky-600" data-id="element-119" />
            🇦🇷 Currículo 2026
          </div>
        </div>

        {/* CTA */}
        <a href="#comprar" className="inline-block bg-orange-500 hover:bg-orange-600 text-white text-base md:text-xl font-bold py-3 md:py-4 px-6 md:px-8 rounded-xl shadow-lg hover:shadow-xl transition-all" data-id="element-120">
          📚 → QUIERO MI LENGUA PACK AHORA
        </a>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 mt-3 md:mt-6 text-[11px] md:text-sm text-gray-500" data-id="element-121">
          <div className="flex items-center gap-1" data-id="element-122">
            <Shield className="w-3.5 h-3.5" data-id="element-123" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-1" data-id="element-124">
            <Lock className="w-3.5 h-3.5" data-id="element-125" /> Pago seguro
          </div>
          <div className="flex items-center gap-1" data-id="element-126">
            <CreditCard className="w-3.5 h-3.5" data-id="element-127" /> Mercado Pago
          </div>
        </div>
      </div>
    </section>;
}